import * as React from "react";
import type { SVGProps } from "react";
export const SvgArrowFillDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="m12 16-6-6h12l-6 6Z" />
  </svg>
);
